import * as t from "io-ts";

/**
 * @deprecated
 */
export type BigIntWithDecimals = t.TypeOf<typeof BigIntWithDecimals>;

export const BigIntWithDecimals = t.type({
  value: t.bigint,
  decimals: t.number,
});
